import * as actionTypes from '../actions/actionTypes'

const initialState = {
    isLoading: false,
    achievements: [],
    blogs: [],
    error: "",
    experiences: [],
    personalInfo: {},
    strengths: [],
    testimonials: [],
    contactInfo: []
}

const dataReducer = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {
        case actionTypes.GET_DATA_INIT:
            return {
                ...initialState,
                isLoading: true,
            }

        case actionTypes.GET_DATA_FAIL:
            if (payload.error !== undefined) {
                return {
                    ...state,
                    isLoading: false,
                    error: payload.error
                }
            }
            return {
                ...state,
                isLoading: false,
            }

        case actionTypes.GET_DATA_SUCCESS:
            return {
                ...state,
                isLoading: false,
                ...payload
            }

        default:
            return { ...state }
    }
}

export default dataReducer